export default function useMoneyFormat(
  n:string|number |null | undefined,
  lang?:string,
  currency?: string,
  style?:string,
  currencyDisplay?: string,
  minimumFractionDigits?: number,
  maximumFractionDigits?: number,
) {
  if (n === null || n === undefined) {
    return '-';
  }

  if (typeof n === 'number') {
    if (currency) {
      return n.toLocaleString(lang, {
        currency, currencyDisplay, style, maximumFractionDigits, minimumFractionDigits,
      });
    }
    return n.toLocaleString();
  }

  return n;
}
